var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CardOrder cardOrder",class:{ 'card-highlight': _vm.isActive },on:{"click":_vm.cardClick}},[_vm._t("cardHeader"),_vm._t("cardBody"),_vm._t("cardFooter")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }